import {RSAA} from "redux-api-middleware";
import {API_ENDPOINT, AUTH_HEADERS} from "../../../util/constants";
import * as types from "../../types";
import {handleUnauthorizedAccess} from "../../../util/utility";

export function getReplyList(token, api_token, comment_id, page) {

    let endpoint = `${API_ENDPOINT}/reply/comment/${comment_id}?`;
    let headers = {
        ...AUTH_HEADERS
    };
    if (api_token !== null) {
        endpoint += `api_token=${api_token}&`;
        headers = {
            ...AUTH_HEADERS,
            Authorization: `Bearer ${token}`
        }
    }

    endpoint += `page=${page}`

    return {
        [RSAA]: {
            endpoint,
            method: 'GET',
            headers,
            types: [types.GET_REPLY_REQUEST, types.GET_REPLY_RECEIVE, {
                type: types.GET_REPLY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetReplyList = () => ({
    type: types.RESET_GET_REPLY,
    payload: null
});

export function createReply(token, api_token,comment_id, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/reply/comment/${comment_id}?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(data),
            types: [types.CREATE_REPLY_REQUEST, types.CREATE_REPLY_RECEIVE, {
                type: types.CREATE_REPLY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetCreateReply = () => ({
    type: types.RESET_CREATE_REPLY,
    payload: null
});

export function updateReply(token, api_token, reply_id,data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/reply/${reply_id}?api_token=${api_token}`,
            method: 'PUT',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(data),
            types: [types.UPDATE_REPLY_REQUEST, types.UPDATE_REPLY_RECEIVE, {
                type: types.UPDATE_REPLY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetUpdateReply = () => ({
    type: types.RESET_UPDATE_REPLY,
    payload: null
});

export function deleteReply(token, api_token, reply_id) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/reply/${reply_id}?api_token=${api_token}`,
            method: 'DELETE',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.DELETE_REPLY_REQUEST, types.DELETE_REPLY_RECEIVE, {
                type: types.DELETE_REPLY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetDeleteReply = () => ({
    type: types.RESET_DELETE_REPLY,
    payload: null
});